import React from 'react';
import PropTypes from 'prop-types';

export const FastTrack = ({ onClick }) => (
  <a
    className="fasttrack fasttrack@desktop"
    onClick={() => onClick(true)}
    href="javascript:void(0)"
  >
    <span className="fasttrack__icon icon icon-item-dots" />{' '}
    <span className="visually-hidden">Fasttrack</span>
  </a>
);

FastTrack.propTypes = {
  onClick: PropTypes.func,
};
